import { useId } from 'react';

export const EmptyContextsIllustration = () => {
  const clipPathId = useId();

  return (
    <svg width="137" height="126" viewBox="0 0 137 126" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M128.5 80H8.5C4.35786 80 1 83.3579 1 87.5V117.5C1 121.642 4.35786 125 8.5 125H128.5C132.642 125 136 121.642 136 117.5V87.5C136 83.3579 132.642 80 128.5 80Z"
          stroke="#CACFD8"
          stroke-dasharray="5 3"
        />
        <path
          d="M126.5 84H10.5C7.46243 84 5 86.4624 5 89.5V115.5C5 118.538 7.46243 121 10.5 121H126.5C129.538 121 132 118.538 132 115.5V89.5C132 86.4624 129.538 84 126.5 84Z"
          fill="white"
        />
        <path
          d="M126.5 84H10.5C7.46243 84 5 86.4624 5 89.5V115.5C5 118.538 7.46243 121 10.5 121H126.5C129.538 121 132 118.538 132 115.5V89.5C132 86.4624 129.538 84 126.5 84Z"
          stroke="#F2F5F8"
        />
        <path
          d="M68.125 102.125V99.875H68.875V102.125H71.125V102.875H68.875V105.125H68.125V102.875H65.875V102.125H68.125Z"
          fill="#99A0AE"
        />
        <path
          d="M128.5 1H8.5C4.35786 1 1 4.35786 1 8.5V38.5C1 42.6421 4.35786 46 8.5 46H128.5C132.642 46 136 42.6421 136 38.5V8.5C136 4.35786 132.642 1 128.5 1Z"
          stroke="#DD2450"
        />
        <path
          d="M126.5 4.5H10.5C7.18629 4.5 4.5 7.18629 4.5 10.5V36.5C4.5 39.8137 7.18629 42.5 10.5 42.5H126.5C129.814 42.5 132.5 39.8137 132.5 36.5V10.5C132.5 7.18629 129.814 4.5 126.5 4.5Z"
          fill="white"
        />
        <path
          d="M73.7246 27.6754H74.7746V28.7254H63.2246V27.6754H64.2746V19.8004C64.2746 19.6612 64.3299 19.5276 64.4284 19.4292C64.5268 19.3307 64.6604 19.2754 64.7996 19.2754H70.0496C70.1888 19.2754 70.3224 19.3307 70.4208 19.4292C70.5193 19.5276 70.5746 19.6612 70.5746 19.8004V27.6754H72.6746V23.4754H71.6246V22.4254H73.1996C73.3388 22.4254 73.4724 22.4807 73.5708 22.5792C73.6693 22.6776 73.7246 22.8112 73.7246 22.9504V27.6754ZM65.3246 20.3254V27.6754H69.5246V20.3254H65.3246ZM66.3746 23.4754H68.4746V24.5254H66.3746V23.4754ZM66.3746 21.3754H68.4746V22.4254H66.3746V21.3754Z"
          fill="#DD2450"
        />
        <path
          d="M126.5 5H10.5C7.46243 5 5 7.46243 5 10.5V36.5C5 39.5376 7.46243 42 10.5 42H126.5C129.538 42 132 39.5376 132 36.5V10.5C132 7.46243 129.538 5 126.5 5Z"
          stroke="#FB3748"
          stroke-opacity="0.24"
        />
        <path
          d="M68.5 49.665V76.335"
          stroke="#CACFD8"
          stroke-width="1.33"
          stroke-linejoin="bevel"
          stroke-dasharray="5 3"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="137" height="126" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
